import * as types from './constants';

export const REDIRECT = 'REDIRECT';
export const showLoading = () => ({
  type: types.SHOW_LOADING,
});

export const getCertificateList = (pageSize, pageIndex, search = '', filters = {}, isFavorite = false, sort = []) => ({
  type: types.GET_CERTIFICATE_LIST,
  pageSize,
  pageIndex,
  search,
  filters,
  isFavorite,
  sort,
});

export const getCertificateListSuccess = (
  certificates,
  total,
  pageIndex = undefined,
  pageSize = undefined
) => ({
  type: types.GET_CERTIFICATE_LIST_SUCCESS,
  certificates,
  total,
  pageIndex,
  pageSize,
});

export const getCertificateListError = (error) => ({
  type: types.GET_CERTIFICATE_LIST_ERROR,
  error,
});


export const getCertificateGridColumnInfo = (gridName) => ({
  type: types.CERTIFICATE_GRID_COLUMN_INFO,
  gridName,
});

export const getCertificateGridColumnInfoSuccess = (columns) => ({
  type: types.CERTIFICATE_GRID_COLUMN_INFO_SUCCESS,
  columns,
});

export const getCertificateGridColumnInfoError = (error) => ({
  type: types.CERTIFICATE_GRID_COLUMN_INFO_ERROR,
  error,
});

export const getCertificateShortDetail = (id) => ({
  type: types.GET_CERTIFICATE_SHORT_DETAIL,
  id,
});

export const getCertificateShortDetailSuccess = (data) => ({
  type: types.GET_CERTIFICATE_SHORT_DETAIL_SUCCESS,
  data,
});

export const getCertificateShortDetailError = (error) => ({
  type: types.GET_CERTIFICATE_SHORT_DETAIL_ERROR,
  error,
});

export const getCertificateFullDetail = (id) => ({
  type: types.GET_CERTIFICATE_FULL_DETAIL,
  id,
});

export const getCertificateFullDetailSuccess = (data) => ({
  type: types.GET_CERTIFICATE_FULL_DETAIL_SUCCESS,
  data,
});

export const getCertificateFullDetailError = (error) => ({
  type: types.GET_CERTIFICATE_FULL_DETAIL_ERROR,
  error,
});

export const getProductsForCertificates = (params) => ({
  type: types.GET_PRODUCTS_FOR_CERTIFICATES,
  params,
});

export const getProductsForCertificatesSuccess = (data) => ({
  type: types.GET_PRODUCTS_FOR_CERTIFICATES_SUCCESS,
  data,
});

export const getProductsForCertificatesError = (error) => ({
  type: types.GET_PRODUCTS_FOR_CERTIFICATES_ERROR,
  error,
});

export const getColumnsCertificatesForMemberSuccess = (columns) => ({
  type: types.GET_COLUMNS_CERTIFICATES_FOR_MEMBER_SUCCESS,
  columns,
});
export const saveIdMember = (id) => ({
  type: types.SAVE_ID_MEMBER,
  id,
});

export const updateCertificateTypePane = () => ({
  type: types.UPDATE_CERTIFICATE_TYPE_PANE,
});

export const updateCertificateTypePaneSuccess = () => ({
  type: types.UPDATE_CERTIFICATE_TYPE_PANE_SUCCESS,
});

export const updateCertificateTypePaneError = () => ({
  type: types.UPDATE_CERTIFICATE_TYPE_PANE_ERROR,
});

export const toggleCertificateNew = (isDisplayCertificateNew) => ({
  type: types.TOGGLE_CERTIFICATE_NEW,
  isDisplayCertificateNew,
});

export const cacheCertificateFromDate = (fromDate) => ({
  type: types.CACHE_CERTIFICATE_FROM_DATE,
  fromDate,
});

// ---- Certificate Grid Column Info ----
export const gridCertificateColumnInfo = (gridName) => ({
  type: types.CERTIFICATE_GRID_COLUMN_INFO,
  gridName,
});

export const gridCertificateColumnInfoSuccess = (columns) => ({
  type: types.CERTIFICATE_GRID_COLUMN_INFO_SUCCESS,
  columns,
});

export const gridCertificateColumnInfoError = (error) => ({
  type: types.CERTIFICATE_GRID_COLUMN_INFO_ERROR,
  error,
});

export const getCertificateDetailGrid = (pageIndex, pageSize, search, filters, sort) => ({
  type: types.GET_CERTIFICATE_DETAIL_GRID,
  pageIndex,
  pageSize,
  search,
  filters,
  sort,
});

export const getCertificateDetailGridSuccess = (data, total) => ({
  type: types.GET_CERTIFICATE_DETAIL_GRID_SUCCESS,
  data,
  total,
});

export const getCertificateDetailGridError = (error) => ({
  type: types.GET_CERTIFICATE_DETAIL_GRID_ERROR,
  error,
});
export const redirectTo = (path) => ({
  type: REDIRECT,
  path,
});

